"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMsgSetWithdrawAddress = exports.MSG_SET_WITHDRAW_ADDRESS_TYPES = exports.createMsgCreateValidator = exports.MSG_CREATE_VALIDATOR_TYPES = exports.createMsgEditValidator = exports.MSG_EDIT_VALIDATOR_TYPES = void 0;
const NOT_MODIFY = '[do-not-modify]';
exports.MSG_EDIT_VALIDATOR_TYPES = {
    TypeDescription: [
        { name: 'moniker', type: 'string' },
        { name: 'identity', type: 'string' },
        { name: 'website', type: 'string' },
        { name: 'security_contact', type: 'string' },
        { name: 'details', type: 'string' },
    ],
    MsgValue: [
        { name: 'description', type: 'TypeDescription' },
        { name: 'validator_address', type: 'string' },
        { name: 'commission_rate', type: 'string' },
        { name: 'min_self_delegation', type: 'string' },
    ],
};
function createMsgEditValidator(moniker, identity, website, securityContact, details, validatorAddress, commissionRate, minSelfDelegation) {
    return {
        type: 'cosmos-sdk/MsgEditValidator',
        value: {
            description: {
                moniker: moniker || NOT_MODIFY,
                identity: identity || NOT_MODIFY,
                website: website || NOT_MODIFY,
                security_contact: securityContact || NOT_MODIFY,
                details: details || NOT_MODIFY,
            },
            validator_address: validatorAddress,
            commission_rate: commissionRate || '<nil>',
            min_self_delegation: minSelfDelegation || '<nil>',
        },
    };
}
exports.createMsgEditValidator = createMsgEditValidator;
exports.MSG_CREATE_VALIDATOR_TYPES = {
    TypeDescription: [
        { name: 'moniker', type: 'string' },
        { name: 'identity', type: 'string' },
        { name: 'website', type: 'string' },
        { name: 'security_contact', type: 'string' },
        { name: 'details', type: 'string' },
    ],
    TypeCommission: [
        { name: 'rate', type: 'string' },
        { name: 'max_rate', type: 'string' },
        { name: 'max_change_rate', type: 'string' },
    ],
    TypePubkey: [
        { name: 'type', type: 'string' },
        { name: 'value', type: 'string' },
    ],
    MsgValue: [
        { name: 'description', type: 'TypeDescription' },
        { name: 'commission', type: 'TypeCommission' },
        { name: 'min_self_delegation', type: 'string' },
        { name: 'delegator_address', type: 'string' },
        { name: 'validator_address', type: 'string' },
        { name: 'pubkey', type: 'TypePubkey' },
        { name: 'value', type: 'TypeValue' },
    ],
    TypeValue: [
        { name: 'denom', type: 'string' },
        { name: 'amount', type: 'string' },
    ],
};
function createMsgCreateValidator(validatorDescription, validatorCommission, minSelfDelegation, delegatorAddress, validatorAddress, amount, denom, pubkey) {
    return {
        type: 'cosmos-sdk/MsgCreateValidator',
        value: {
            commission: {
                max_change_rate: validatorCommission.maxChangeRate,
                max_rate: validatorCommission.maxRate,
                rate: validatorCommission.rate,
            },
            delegator_address: delegatorAddress,
            description: {
                details: validatorDescription.details,
                identity: validatorDescription.identity,
                moniker: validatorDescription.moniker,
                security_contact: validatorDescription.securityContact,
                website: validatorDescription.website,
            },
            min_self_delegation: minSelfDelegation,
            pubkey: {
                type: 'tendermint/PubKeyEd25519',
                value: pubkey,
            },
            validator_address: validatorAddress,
            value: {
                amount,
                denom,
            },
        },
    };
}
exports.createMsgCreateValidator = createMsgCreateValidator;
exports.MSG_SET_WITHDRAW_ADDRESS_TYPES = {
    MsgValue: [
        { name: 'delegator_address', type: 'string' },
        { name: 'withdraw_address', type: 'string' },
    ],
};
function createMsgSetWithdrawAddress(delegatorAddress, withdrawAddress) {
    return {
        type: 'cosmos-sdk/MsgModifyWithdrawAddress',
        value: {
            delegator_address: delegatorAddress,
            withdraw_address: withdrawAddress,
        },
    };
}
exports.createMsgSetWithdrawAddress = createMsgSetWithdrawAddress;
//# sourceMappingURL=validator.js.map